import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Checkbox } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
  watchEnableVerticalPodAutoScaler: boolean;
};

/**
 * Vertical Pod AutoScaler有効フラグのフォームのベースです。
 * NOTE: Chakra の Checkbox は非制御コンポーネントなので、react-hook-form の register でフォーム化しています。
 */
export const EnableVerticalPodAutoScalerFormBase: FC<Props> = ({
  register,
  watchEnableVerticalPodAutoScaler,
}) => (
  <Checkbox
    id="enableVerticalPodAutoScaler"
    isChecked={watchEnableVerticalPodAutoScaler}
    {...register('enableVerticalPodAutoScaler', {
      required: {
        value: false, // boolean値の場合は常にfalseで良い（値の存在確認）
        message: 'VPA設定の選択は必須です。',
      },
    })}
  >
    Vertical Pod AutoScalerを有効にする
  </Checkbox>
);
